import React, { useState } from "react";
import DriverSidebar from "components/Sidebars/DriverSidebar";
import CustomerSidebar from "components/Sidebars/CustomerSidebar";
import DriverProfileSetting from "./DriverTabs/ProfileSetting";
import DriverBookings from "./DriverTabs/Bookings";
import DriverVehicles from "./DriverTabs/Vehicles";
import CustomerBookings from "./CustomerTabs/Bookings";
import CustomerProfileSetting from "./CustomerTabs/ProfileSetting";

const Profile = () => {
  document.title = "Profile | Sawari Online";
  const authUser = JSON.parse(localStorage.getItem("authClient"));

  const [activeTab, setActiveTab] = useState("profile");

  if (authUser?.user_type === 'C') {
    return (
      <div className="content">
        <div className="container">
          <h2 className="fw-600 truncate-2 mb-4 sec-subtitle">Dashboard</h2>
          <div className="row">
            <CustomerSidebar activeTab={activeTab} setActiveTab={setActiveTab} />
            <div className="col-12 col-lg-8 col-xl-9">
              {activeTab === "profile" && <CustomerProfileSetting />}
              {activeTab === "bookings" && <CustomerBookings />}
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (authUser?.user_type === 'D') {
    return (
      <div className="content">
        <div className="container">
          <h2 className="fw-600 truncate-2 mb-4 sec-subtitle">Dashboard</h2>
          <div className="row">
            <DriverSidebar activeTab={activeTab} setActiveTab={setActiveTab} />
            <div className="col-12 col-lg-8 col-xl-9">
              {activeTab === "profile" && <DriverProfileSetting />}
              {activeTab === "bookings" && <DriverBookings />}
              {activeTab === "vehicles" && <DriverVehicles />}
            </div>
          </div>
        </div>
      </div>
    );
  }

};

export default Profile;
